module.exports = __webpack_public_path__ + "static/media/tumblr.af96aa10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tumblr.png
// module id = 141
// module chunks = 0